<template>
    <section class="bhub-section" style="margin: 0 auto;"> 
        <div style="display: block; width: 160px; height: 90px; margin: 0 auto;" v-if="mobile">
            <div style="height: 160px;">
            <v-chart
                v-if="displayed"
                :option="chartOptionsMobile"
                :init-options="initOptions"
                ref="bar"
                width="160"
                height="100"
            />
            </div>
        </div>
        <div style="display: block; width: 360px; height: 300px; margin: 0 auto;" v-else>
            <v-chart
                v-if="displayed"
                :option="chartOptions"
                :init-options="initOptions"
                ref="bar"
                width="360"
                height="400"
            />
        </div>
    </section>
</template>
<script>
export default {
    props: {
        displayed: Boolean,
        mobile: Boolean,
        label: String,
        value: Number,
    },
    data() {
        return {
            initOptions: {
                renderer: "canvas",
            },
        };
    },
    watch: {
        displayed(v) {
            if (v) {
                //this.$refs['bar'].resize(200,100)
            }
        },
    },
    computed: {
        chartOptions() {
            return {
                series: [
                    {                            
                        cursor: "default",

                        type: "gauge",
                        grid: {
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: -50,
                        },
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 1,
                        axisLine: {
                            lineStyle: {
                                width: 20,
                                color: [
                                    [0.3, "#E83162"],
                                    [0.7, "#FFED00"],
                                    [1, "#7DB91E"],
                                ],
                            },
                        },
                        pointer: {
                            cursor: "wait",
                            itemStyle: {
                                color: "#009EE3",
                            },
                        },
                        axisTick: {
                            show: false,
                            distance: -40,
                            length: 8,
                            lineStyle: {
                                color: "#fa0",
                                width: 2,
                            },
                        },
                        splitLine: {
                            show: false,
                            distance: -28,
                            length: 28,
                            lineStyle: {
                                color: "#fff",
                                width: 4,
                            },
                        },
                        axisLabel: {
                            show: true,
                            color: "auto",
                            nodistance: -28,
                            distance: 0,
                            fontSize: 15,
                            align: "center",
                            rich: {
                                a: {
                                    verticalAlign: "bottom",
                                    fontSize: 18,
                                    lineHeight: 40,
                                }

                            },
                                formatter: "{a|{value}}"
                        },
                        detail: {
                            show: true,
                            cursor: "default",
                            valueAnimation: true,
                            color: "#009EE3",
                        },
                        data: [
                            {
                                value: Math.round(this.value),
                            },
                        ],
                    },
                ],
            };
        },
        chartOptionsMobile() {
            return {
                series: [
                    {
                        type: "gauge",
                        grid: {
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                        },
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        
                        axisLine: {
                            lineStyle: {
                                width: 20,
                                color: [
                                    [0.3, "#E83162"],
                                    [0.7, "#FFED00"],
                                    [1, "#7DB91E"],
                                ],
                            },
                        },
                        pointer: {
                            itemStyle: {
                                color: "#009EE3",
                            },
                        },
                        axisTick: {
                            show: false,
                            distance: -30,
                            length: 8,
                            lineStyle: {
                                color: "#fa0",
                                width: 2,
                            },
                        },
                        splitLine: {
                            show: false,
                            distance: -28,
                            length: 28,
                            lineStyle: {
                                color: "#fff",
                                width: 4,
                            },
                        },
                        axisLabel: {
                            show: false,
                            color: "auto",
                            distance: -28,
                            fontSize: 15,
                        },
                        detail: {
                            show: true,
                            valueAnimation: true,
                            color: "#009EE3",
                            fontSize: 15,
                        },
                        data: [
                            {
                                value: Math.round(this.value),
                            },
                        ],
                    },
                ],
            };
        },
    },
};
</script>
